import _ from 'underscore';

let i18n = null;
export function initialize(options) {
  ({
    i18n,
  } = options);
}


export function appendPopProperties(entitySchema) {
  const popPrefix = 'PoP';
  const biPattern = /^(Phone)?PerformanceMetrics\//;
  const biReplacePattern = /PerformanceMetrics\//;
  const biChange = 'PerformanceMetricsChange/';
  const biChangePercent = 'PerformanceMetricsChangePercentage/';

  const biTitlePrefix = 'ColumnName_';
  const biTitleComparePostfix = '_Compare';
  const biTitleChangePostfix = '_Change';
  const biTitleChangePercentPostfix = '_Change_Percentage';
  const customColumnStr = 'CustomColumn';

  _.each(entitySchema.properties, (propObj) => {
    const { properties } = entitySchema;
    if (biPattern.test(propObj.property)) {
      const isCustomColumn = propObj.customColumn ||
        (propObj.originalProperty && propObj.originalProperty.indexOf(customColumnStr) === 0);
      const propName = isCustomColumn ? customColumnStr : propObj.property.split('/')[1];
      const propKey = isCustomColumn ? propObj.originalProperty : propObj.name;
      properties[`${popPrefix}${propKey}`] = _.defaults({
        name: `${popPrefix}${propObj.name}`,
        property: `${popPrefix}${propObj.property}`,
        title: biTitlePrefix + propName + biTitleComparePostfix,
        unlocalized: true,
        alias: null,
        originalProperty: `${popPrefix}${propObj.originalProperty}`,
        originalTitle: propObj.title,
      }, propObj);
      properties[`${popPrefix}${propKey}Change`] = _.defaults({
        name: `${popPrefix}${propObj.name}Change`,
        property: `${popPrefix}${propObj.property.replace(biReplacePattern, biChange)}`,
        title: biTitlePrefix + propName + biTitleChangePostfix,
        unlocalized: true,
        alias: null,
        originalProperty: `${popPrefix}${propObj.originalProperty}Change`,
        originalTitle: propObj.title,
      }, propObj);
      properties[`${popPrefix}${propKey}ChangePercent`] = _.defaults({
        name: `${popPrefix}${propObj.name}ChangePercent`,
        property: `${popPrefix}${propObj.property.replace(biReplacePattern, biChangePercent)}`,
        originalProperty: `${popPrefix}${propObj.originalProperty}ChangePercent`,
        title: biTitlePrefix + propName + biTitleChangePercentPostfix,
        type: 'number',
        isPercentValue: true,
        minimum: -9007199254740991, // Number.MIN_SAFE_INTEGER
        maximum: 9007199254740991, // Number.MAX_SAFE_INTEGER
        unlocalized: true,
        alias: null,
        originalTitle: propObj.title,
      }, propObj);
    }
  });
}

export function appendPeriodOverPeriodProperties(entitySchema) {
  appendPopProperties(entitySchema);

  _.each(entitySchema.properties, (prop) => {
    const propCopy = prop;
    if (propCopy.unlocalized) {
      propCopy.title = propCopy.customColumn || (propCopy.originalProperty && propCopy.originalProperty.indexOf('CustomColumn') >= 0) ?
        i18n.getString(prop.title).replace('{0}', prop.originalTitle) :
        i18n.getString(prop.title);
      delete propCopy.unlocalized;
      delete propCopy.originalTitle;
    }
  });
}
